<div class="form-group has-feedback"  [class.has-success]="hasSuccess()" [class.has-error]="hasError()">
    
  <label class="control-label" for="inputSuccess">{{ label }}</label>

  <ng-content></ng-content>
 
  <span class="help-block" *ngIf="hasSuccess()"><i class="fa fa-check"></i>Ok</span>
  <span class="help-block" *ngIf="hasError()"><i class="fa fa-remove"></i>{{ errorMessage }}</span>

</div>